import React from 'react';
import PropTypes from 'prop-types';
import classes from './NavA.module.scss';

const NavA = (props) => {
  const {
    header, nodes,
  } = props;

  return (
    <div>
      {header && <span
        className={classes.header}
        dangerouslySetInnerHTML={{ __html: header }}
      />}
      {nodes && nodes.length > 0 &&
      <ul
        className={classes.list}
      >
        {nodes.map((node, index) => (
          <li key={index}>
            <a aria-label={node.title} href={node.url} target={node.linkTarget}>
              <span dangerouslySetInnerHTML={{ __html: node.title }} />
            </a>
          </li>
        ))}
      </ul>}
    </div>
  );
};

NavA.propTypes = {
  /**
   * Text displays at the top of the component
  */
  header: PropTypes.string,
  /**
   * A list of links that display directly below the header
  */
  nodes: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    linkTarget: PropTypes.string,
    title: PropTypes.string,
  })),
};

export default NavA;
